import { Reveal, MaskedLine } from "@/components/Reveal";

const TILES = [
  { img: "/images/stickers/elem-eye.webp", label: "EYES", rot: "-rotate-2" },
  { img: "/images/stickers/sticker-leopardcroc.webp", label: "ANIMALS", rot: "rotate-1" },
  { img: "/images/stickers/sticker-chaos.webp", label: "CHAOS", rot: "-rotate-1" },
  { img: "/images/stickers/elem-skeleton.webp", label: "SKELETONS", rot: "rotate-2" },
  { img: "/images/stickers/elem-trumpets.webp", label: "TRUMPETS", rot: "-rotate-2" },
  { img: "/images/stickers/sticker-foot.webp", label: "FEET", rot: "rotate-1" },
];

const LINES = ["IT'S LOUD.", "IT'S RIDICULOUS.", "IT'S UNCOMFORTABLE.", "IT'S COLOURFUL."];

export default function LookCloser() {
  return (
    <section data-testid="look-closer-section" className="bg-pink text-black py-24 sm:py-32 overflow-hidden">
      <div className="mx-auto max-w-7xl px-5 sm:px-10">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <h2 className="font-display leading-[0.85]">
            <MaskedLine inView className="text-[clamp(3rem,10vw,9rem)]">
              LOOK CLOSER.
            </MaskedLine>
          </h2>
          <svg className="scribble-draw w-40 h-12 hidden sm:block" viewBox="0 0 160 48" fill="none" aria-hidden>
            <path d="M4 30 C 40 10, 70 44, 105 22 S 150 26, 156 14" stroke="#0D0D0D" strokeWidth="4" strokeLinecap="round" />
            <path d="M140 8 L 156 14 L 146 28" stroke="#0D0D0D" strokeWidth="4" strokeLinecap="round" />
          </svg>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-8 mt-14">
          {TILES.map((t, i) => (
            <Reveal key={t.label} delay={(i % 3) * 0.08} className={t.rot}>
              <figure className="group bg-paper p-2.5 sm:p-3 border-2 border-black shadow-[6px_6px_0_#0D0D0D]" data-testid={`detail-${t.label.toLowerCase()}`} data-cursor="look">
                <div className="overflow-hidden bg-black">
                  <img
              loading="lazy"
              decoding="async"
                    src={t.img}
                    alt={`Artwork detail — ${t.label}`}
                    className="w-full h-40 sm:h-60 object-contain p-3 sm:p-4 transition-transform duration-700 group-hover:scale-110"
                  />
                </div>
                <figcaption className="flex items-center justify-between pt-2.5">
                  <span className="font-sans font-bold text-[11px] sm:text-xs tracking-[0.3em]">{t.label}</span>
                  <span className="font-hand text-xl sm:text-2xl text-black/70">fig. 0{i + 1}</span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>

        <div className="mt-16 sm:mt-20 max-w-3xl">
          {LINES.map((l, i) => (
            <MaskedLine key={l} inView delay={i * 0.06} className="font-display text-[clamp(1.8rem,5vw,4rem)] leading-[1.02]">
              {l}
            </MaskedLine>
          ))}
          <MaskedLine inView delay={0.3} className="font-display text-[clamp(1.8rem,5vw,4rem)] leading-[1.02] text-paper">
            EXACTLY AS IT SHOULD BE.
          </MaskedLine>
        </div>
      </div>
    </section>
  );
}
